// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailFlowTemplate_flow_template_container__b\\+hOb {
  display: flex;
  flex-direction: column;
  color: var(--color-theme-10);

  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.EmailFlowTemplate_flow_input__EnQ97 {
  text-decoration: none;
  margin: 10px 0 !important;
  background-color: var(--color-bg-caselist);
  width: 100%;
}

.EmailFlowTemplate_flow_input__EnQ97 input {
  text-overflow: ellipsis;
}

.EmailFlowTemplate_divider__gjR9f {
  margin: 10px;
  display: flex;
  align-items: center;
  width: 100%;
}

.EmailFlowTemplate_divider_line__SWL1Z {
  flex: 1 1;
  border-bottom: 1px solid black;
}

.EmailFlowTemplate_divider_word__WsTqC {
  padding: 0 10px;
}

.EmailFlowTemplate_trigger_scheduled__4RvD- {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.EmailFlowTemplate_disabled__6kPCe {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/EmailFlowTemplate/EmailFlowTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;;EAE5B,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,YAAY;AACd","sourcesContent":[".flow_template_container {\n  display: flex;\n  flex-direction: column;\n  color: var(--color-theme-10);\n\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.flow_input {\n  text-decoration: none;\n  margin: 10px 0 !important;\n  background-color: var(--color-bg-caselist);\n  width: 100%;\n}\n\n.flow_input input {\n  text-overflow: ellipsis;\n}\n\n.divider {\n  margin: 10px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.divider_line {\n  flex: 1;\n  border-bottom: 1px solid black;\n}\n\n.divider_word {\n  padding: 0 10px;\n}\n\n.trigger_scheduled {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.disabled {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flow_template_container": `EmailFlowTemplate_flow_template_container__b+hOb`,
	"flow_input": `EmailFlowTemplate_flow_input__EnQ97`,
	"divider": `EmailFlowTemplate_divider__gjR9f`,
	"divider_line": `EmailFlowTemplate_divider_line__SWL1Z`,
	"divider_word": `EmailFlowTemplate_divider_word__WsTqC`,
	"trigger_scheduled": `EmailFlowTemplate_trigger_scheduled__4RvD-`,
	"disabled": `EmailFlowTemplate_disabled__6kPCe`
};
export default ___CSS_LOADER_EXPORT___;
